import {
  confirmSchedule,
  markVisited,
  markNoshow,
} from "@/api/providerDashboard";
import { isPastOrCurrentReservationDateTime } from "@/utils/reservationDateTime";

export default {
  canCompleteVisit(item, now = new Date()) {
    return Boolean(
      item &&
        item.status === "confirmed" &&
        isPastOrCurrentReservationDateTime(item.date, item.time, now)
    );
  },
  async handleConfirm(id) {
    try {
      await this.$confirm("예약을 확정하시겠습니까?", {
        confirmButtonText: "확정",
        cancelButtonText: "취소",
      });
      await confirmSchedule(id);
      this.$message.success("예약이 확정되었습니다.");
      this.loadSchedules();
    } catch (error) {
      const responseMessage =
        error.response && error.response.data && error.response.data.message;
      if (responseMessage) {
        this.$message.error(responseMessage);
        this.loadSchedules();
      }
    }
  },
  async handleVisited(id) {
    const item = this.scheduleList.find((schedule) => schedule._id === id);
    if (!this.canCompleteVisit(item)) return;

    try {
      await this.$confirm("방문 완료 처리하시겠습니까?", {
        confirmButtonText: "확인",
        cancelButtonText: "취소",
      });
      await markVisited(id);
      this.$message.success("방문 완료 처리되었습니다.");
      this.loadSchedules();
    } catch (e) {
      /* cancelled */
    }
  },
  async handleNoshow(id) {
    try {
      await this.$confirm("노쇼 처리하시겠습니까?", {
        confirmButtonText: "확인",
        cancelButtonText: "취소",
      });
      await markNoshow(id);
      this.$message.success("노쇼 처리되었습니다.");
      this.loadSchedules();
    } catch (e) {
      /* cancelled */
    }
  },
};
